import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { ArrowBackIos, ArrowForwardIos, Close } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import useLocales from 'src/hooks/useLocales';

export const DialogSection = ({
  as = 'body2',
  hideBorder = false,
  backUrl,
  title,
  subTitle,
  sx,
  variant = 'elevation',
  children,
  elevation = 1,
  Control,
  ...props
}) => {
  const { isRTL } = useLocales();
  const navigate = useNavigate();
  return (
    <Box sx={{ my: 1, p: 2, ...sx }} variant={variant} elevation={elevation}>
      <Stack flex flexDirection="column" gap="1rem" justifyContent="start" alignItems="start">
        {(title || Control) && (
          <Box sx={{ width: props.width || '100%' }}>
            <Stack
              flex
              flexDirection="row"
              gap={1}
              alignItems="center"
              alignContent="center"
              justifyContent="space-between"
            >
              <Stack flex flexDirection="row" gap={1} alignItems="center" alignContent="center">
                {typeof backUrl == typeof '' && (
                  <IconButton size="small" color={props.color} onClick={() => navigate(backUrl)}>
                    {isRTL() ? <ArrowForwardIos /> : <ArrowBackIos />}
                  </IconButton>
                )}
                {typeof backUrl == 'function' && (
                  <IconButton size="small" color={props.color} onClick={() => backUrl()}>
                    <Close />
                  </IconButton>
                )}
                <Stack flex flexDirection="column" gap={1} alignItems="center">
                  <Typography color={props.color} variant={as} {...props}>
                    {title}
                  </Typography>
                  {subTitle && <span>{subTitle}</span>}
                </Stack>
              </Stack>

              {Control}
            </Stack>
            {!hideBorder && <Divider sx={{ mt: 1, backgroundColor: grey[200] }} />}
          </Box>
        )}
        <Box sx={{ width: '100%' }}>{children}</Box>
      </Stack>
    </Box>
  );
};
